import { useTheme } from '@material-ui/core';
import React from 'react';
import RenderConditionally from './RenderConditionally';

const RenderDesktop = ({ children }) => {
  const theme = useTheme();
  return (
    <RenderConditionally query={theme.breakpoints.up('md')}>
      {children}
    </RenderConditionally>
  );
};

export default RenderDesktop;
